<template>
  <div class="flex items-center">
    <span>{{ params.value }}</span>
    <vs-progress :percent="percent" :color="color"></vs-progress>
  </div>
</template>

<script>
export default {
  name: 'CellRendererDistance',
  computed: {
    percent () { return 10 },
    color () {
      if (this.params.data.estimatedDeliveryDate === null || this.params.data.transitState === 'delivered') return 'success'
      const dateNow = new Date(Date.now())
      const estimatedDeliveryDate = new Date(this.params.data.estimatedDeliveryDate)
      return dateNow <= estimatedDeliveryDate ? 'success' : 'danger'
    }
  }
}
</script>
